module.exports = __webpack_public_path__ + "img/cloud-drizzle-lightning-sun-2.1072dd92.svg";